module.exports = __webpack_public_path__ + "da222e255e4f734618ad99252a8d4940.png";